import { UsageGridBase } from './UsageGridBase.js';
import type { ResourceUsageProps } from './types.js';

/**
 * 資源使用狀況：資源 → 其下的指派任務，右側逐時段格線（日／週／月）。
 * 純展示元件。
 */
export function ResourceUsage(props: ResourceUsageProps): React.JSX.Element {
  return <UsageGridBase {...props} testIdPrefix="resource-usage" groupLabelHeader="資源" />;
}

export default ResourceUsage;
